<template>
    <div>
        <!-- 历史名人 -->
        <div>
            <person-list :list="result.celebrity"/>
        </div>
        <!-- 综合 -->
        <div>
            <mix-resource-list :list="result.resources.records"/>
        </div>

        <empty v-if="!loading && isEmpty" />
    </div>
</template>

<script>
import Empty from '@/components/empty'
import PersonList from "./personList";
import MixResourceList from "@/components/mixResourceList"

export default {
    name: 'MixList',
    components: {
        PersonList,
        Empty,
        MixResourceList
    },
    props: {
        result: {
            type: Object
        },
        loading:{
            type:Boolean,
            require:true,
            default:false,
        }
    },
    created() {
        this.init()
    },
    computed:{
        isEmpty(){
            if(!this.result) return true
            const r = this.result
            const celebrityEmpty = !r.celebrity || !r.celebrity.length
            const resourceEmpty = !r.resources || !r.resources.records
                || !r.resources.records.length
            return celebrityEmpty && resourceEmpty
        }
    },
    methods:{
        init(){
        }
    }
}
</script>

<style scoped>

</style>

